import { getFirestore } from "firebase/firestore";
import { app } from "../lib/firebase";

// Use the Firebase app instance from lib/firebase.js
// This prevents "duplicate app" errors
const db = getFirestore(app);

// REMOVED: enableIndexedDbPersistence 
// Reason: This was causing "INTERNAL ASSERTION FAILED: Unexpected state" errors
// when multiple listeners were active. Firestore will still work without persistence,
// just without offline support. Re-enable only if needed and with proper error handling.

export { db };
